import React, { useState } from "react";
import Control from "../../common/Control";
import { DateTime } from "luxon";

const FormGenerator = ({
  schema,
  initialValues = {},
  handleChange,
  nbCols = 4,
}) => {
  const formData = initialValues;

  const [errors] = useState({});

  // Récupérer les propriétés du schéma principal
  const [schemaName] = Object.keys(schema);
  const properties = schema[schemaName].properties;
  const requiredFields = schema[schemaName].required || [];

  // Déterminer le type d'input en fonction du type de la propriété
  const getInputType = (property) => {
    if (property.$ref) return "select";

    switch (property.type) {
      case "string":
        if (property.format === "select") return "select";
        if (property.format === "date-time") return "date";
        if (property.format === "email") return "email";
        return "text";
      case "number":
        return "number";
      case "integer":
        return "number";
      case "boolean":
        return "checkbox";
      default:
        return "text";
    }
  };

  // Convertir les valeurs enum ou values en format attendu par le composant Control
  const getSelectOptions = (property) => {
    if (property.format !== "select") return [];

    if (property.values) {
      return property.values.map((val) => ({
        id: val.value,
        name: `(${val.value}) ${val.description}`,
      }));
    }

    if (property.enum) {
      return property.enum.map((val) => ({
        id: val,
        name: val,
      }));
    }

    return [];
  };

  // Grouper les propriétés par catégorie
  const groupedProperties = Object.entries(properties).reduce(
    (acc, [name, property]) => {
      const category = property.category || "Autre";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push([name, property]);
      return acc;
    },
    {},
  );

  // S'assurer que "Obligatoire" apparaît en premier
  const orderedCategories = [
    "Obligatoire",
    ...(schema[schemaName].categories?.filter((cat) => cat !== "Obligatoire") ||
      []),
  ];

  return (
    <div className="mt-2">
      <form>
        {orderedCategories.map((category) => {
          const categoryProperties = groupedProperties[category];
          if (!categoryProperties?.length) return null;

          //check if category has any enabled properties
          const hasEnabledProperties = categoryProperties.some(
            ([, property]) => !property.disabled,
          );
          if (!hasEnabledProperties) return null;

          return (
            <div key={category} className="mb-4">
              <h5 className="mb-3">{category}</h5>
              <div className="row">
                {categoryProperties.map(([name, property]) => {
                  // Ignorer les propriétés avec références pour l'instant
                  if (property.$ref) return null;

                  const inputType = getInputType(property);
                  const isRequired = requiredFields.includes(name);
                  if (property.disabled) return null;

                  return (
                    <div key={name} className={`col-12 col-md-${nbCols} mb-1`}>
                      <Control
                        label={property.description || name}
                        type={inputType}
                        name={name}
                        value={
                          inputType === "date"
                            ? DateTime.fromISO(formData[name]).toFormat(
                                "yyyy-MM-dd",
                              )
                            : formData[name] || ""
                        }
                        change={handleChange}
                        error={errors}
                        required={isRequired}
                        disabled={property.frozen}
                        className="mb-0"
                        datas={
                          inputType === "select"
                            ? getSelectOptions(property)
                            : false
                        }
                      />
                      {property.comment && (
                        <small className="form-text text-muted mt-1">
                          {property.comment}
                        </small>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </form>
    </div>
  );
};

export default FormGenerator;
